var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPersonWithCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 8C9.706 8 11.5 6.206 11.5 4C11.5 1.794 9.706 0 7.5 0C5.294 0 3.5 1.794 3.5 4C3.5 6.206 5.294 8 7.5 8ZM19.1563 1.2456C18.7393 0.8836 18.1083 0.9266 17.7453 1.3436L15.8793 3.4886L15.2453 2.7796C14.8783 2.3676 14.2463 2.3326 13.8333 2.7016C13.4223 3.0696 13.3863 3.7026 13.7553 4.1136L15.1443 5.6666C15.3343 5.8786 15.6053 5.9996 15.8893 5.9996H15.8963C16.1833 5.9976 16.4563 5.8726 16.6443 5.6566L19.2553 2.6566C19.6173 2.2396 19.5733 1.6076 19.1563 1.2456ZM14.5 17C14.5 17.552 14.053 18 13.5 18H1.5C0.947 18 0.5 17.552 0.5 17C0.5 13.14 3.641 10 7.5 10C11.359 10 14.5 13.14 14.5 17Z",
    fill: "#00A0F3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonWithCheck);
export default __webpack_public_path__ + "static/media/PersonWithCheck.53c36fde.svg";
export { ForwardRef as ReactComponent };